// removed by extract-text-webpack-plugin
module.exports = {"button-link":"button-link__3icW1","with-arrow":"with-arrow__2GYPw","disabled":"disabled__1TNs8","arrow":"arrow__1wuvC","text":"text__1S19c"};


//////////////////
// WEBPACK FOOTER
// ./components/button/styles/ButtonLink.scss
// module id = wKHB
// module chunks = 1